export const capitalize = (s) => {
    return s.charAt(0).toUpperCase() + s.slice(1);
};
export const toTitleCase = (s) => {
    return s
        .split(/[_-]|(?=[A-Z])/)
        .filter((word) => word.length > 0)
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};
const trimIsoMS = (date) => {
    return date.toISOString().replace(/\.\d+Z/, 'Z');
};
export const sanitizeFilters = (filters) => {
    const out = {};
    for (const [key, value] of Object.entries(filters)) {
        if (Array.isArray(value)) {
            const filter = value;
            if (filter.length === 1) {
                out[key] = filter[0].trim();
            }
        }
        if (typeof value === 'string') {
            out[key] = value.trim();
            continue;
        }
        if (typeof value === 'number' || typeof value === 'boolean') {
            out[key] = value;
        }
        if (value instanceof Date) {
            out[key] = trimIsoMS(value);
        }
    }
    return out;
};
